module.exports = __webpack_public_path__ + "img/status-cancelled.279f1d54.svg";